import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="my-16 p-8 md:p-10 bg-white border border-gray-200 rounded-xl shadow-sm" data-id="element-36">
      <h3 className="text-2xl md:text-3xl font-bold mb-8 text-gray-900" data-id="element-37">
        Na dit gratis webinar heeft je hond ineens ondertiteling
      </h3>

      <ul className="space-y-5 mb-10" data-id="element-38">
        {['De signalen die je hond de hele dag geeft (en wat ze betekenen)', 'Waarom je hond soms niet "luistert" — en wat je daaraan kunt doen', 'Hoe je communiceert op een manier die je hond wél begrijpt', 'De grootste miscommunicaties tussen mens en hond (en hoe je ze voorkomt)'].map((item, index) => <li key={index} className="flex items-start" data-id="element-39">
            <div className="mt-1 mr-4 flex-shrink-0 text-[#2563EB]" data-id="element-40">
              <Check size={20} strokeWidth={3} data-id="element-41" />
            </div>
            <span className="text-gray-700 text-lg" data-id="element-42">{item}</span>
          </li>)}
      </ul>

      <div className="mb-10 text-base text-gray-600 bg-gray-50 p-6 rounded-lg border border-gray-100" data-id="element-43">
        <p data-id="element-44">
          Het webinar wordt gegeven door{' '}
          <strong className="text-gray-900" data-id="element-45">Amee de Bruijn</strong>,
          gediplomeerd hondengedragsconsulent die al meer dan 15.000 honden en
          hun baasjes heeft geholpen.
        </p>
      </div>

      <div className="text-center" data-id="element-46">
        <motion.a href="https://stresslessdogs.nl/mc-communiceren" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex w-full md:w-auto bg-[#2563EB] text-white font-semibold text-lg py-4 px-8 rounded-lg shadow-md hover:bg-blue-700 transition-colors items-center justify-center mx-auto mb-4" data-id="element-47">
          Bekijk wanneer het volgende webinar is
          <ArrowRight className="ml-2" size={20} data-id="element-48" />
        </motion.a>
        <p className="text-sm text-gray-500" data-id="element-49">
          Meld je gratis aan voor het webinar
        </p>
      </div>
    </section>;
}